<script setup>
import BaseDialogDelete from '@/components/base/BaseDialogDelete.vue';

const open = defineModel('open');
const adminName = defineModel('adminName');
</script>

<template>
    <BaseDialogDelete
        v-model:open="open"
        title="確認刪除管理者"
        :content="`確定要刪除 <span class='text-red-500 font-bold'>${adminName}</span> 管理者嗎？此操作無法復原。`"
        ok-text="確認刪除"
        cancel-text="取消"
        :width="520"
        bodyHeight="auto"
        @confirm="$emit('confirm', $event)"
    />
</template>
